import {
  CLEAN_MAP,
  SET_ACTIVE_DATA,
  SHOW_SUITABILITY_LAYER,
  HIDE_SUITABILITY_LAYER,
  SET_MARKER,
  SET_ACTIVE_LAYER_GROUP,
  RESET_LAYER_GROUP
} from "./types";

import utils from "./map-helpers.js";

export default {
  cleanMap(context) {
    context.commit(CLEAN_MAP);
  },
  changeActiveData(context, payload) {
    context.commit(SET_ACTIVE_DATA, payload);
  },
  changeSuitabilityLayer(context, layerConfig) {
    if (layerConfig.show) {
      const newOptions = context.state.wmsLayerSuitability.options;
      newOptions.layers = layerConfig.layer.name;
      const wmsThreddsOptions = utils.getWMSRequestObj(
        context.getters.activeScale.name,
        context.getters.activeSector.name,
        layerConfig,
        newOptions
      );
      context.commit(SHOW_SUITABILITY_LAYER, wmsThreddsOptions);
      context.commit(SET_ACTIVE_LAYER_GROUP, layerConfig.metadata.groupName);
    } else {
      context.commit(HIDE_SUITABILITY_LAYER);
      context.commit(SET_ACTIVE_LAYER_GROUP, "");
    }
  },
  setScToolPoint(context, point) {
    context.commit(SET_MARKER, point);
  },
  resetLayerGroup(context) {
    context.commit(RESET_LAYER_GROUP);
  }
};
